import React from "react";
import cns from "classnames";
import FormField from "@modules/formx-react/FormField";
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButton,
  ToggleButtonProps
} from "@material-ui/lab";
import {
  makeStyles,
  FormControl,
  FormLabel,
  FormLabelProps,
  FormHelperText
} from "@material-ui/core";
import { ThemeType } from "@theme";

export type ToggleButtonGroupProps = {
  value: any;
  label: React.ReactNode;
  disabled?: boolean;
};

export type Props = {
  label?: string;
  name: string;
  ButtonProps?: ToggleButtonProps;
  LabelProps?: FormLabelProps;
  options: ToggleButtonGroupProps[];
  helperText?: string;
  exclusive?: boolean;
  wrap?: boolean;
  hideErrorLabel?: boolean;
};

export const ToggleButtonGroup = (props: Props) => {
  const {
    label,
    name,
    ButtonProps,
    LabelProps,
    options,
    helperText,
    exclusive = true,
    wrap = false
  } = props;
  const classes = useStyles({});

  return (
    <FormField name={name}>
      {(field) => (
        <FormControl error={field.invalid}>
          <div className={classes.labelRoot}>
            {((field.error && !props.hideErrorLabel) || label) && (
              <FormLabel {...LabelProps}>{field.error || label}</FormLabel>
            )}

            {helperText && <FormHelperText>{helperText}</FormHelperText>}
          </div>

          <MuiToggleButtonGroup
            exclusive={exclusive}
            value={field.fieldProps.value}
            onChange={(ev, value) => field.fieldProps?.onChange(value)}
            className={cns({ [classes.error]: !!field.error, [classes.wrap]: wrap })}
          >
            {options?.map((option, i) => {
              return (
                <ToggleButton
                  key={i}
                  disabled={field.disabled || option.disabled}
                  value={option.value}
                  {...ButtonProps}
                >
                  {option.label}
                </ToggleButton>
              );
            })}
          </MuiToggleButtonGroup>
        </FormControl>
      )}
    </FormField>
  );
};

const useStyles = makeStyles((theme: ThemeType) => {
  const errorBorderStyle = `1px solid ${theme.palette.error.main}`;

  return {
    labelRoot: {
      marginBottom: "10px"
    },
    wrap: {
      flexWrap: "wrap",
      "&& > button": {
        margin: "1px",
        borderLeft: `1px solid rgba(0, 0, 0, 0.12)`,
        borderRadius: 4
      },
      "&&[class*='error'] > button": {
        border: errorBorderStyle
      }
    },
    error: {
      "& > button": {
        borderTop: errorBorderStyle,
        borderBottom: errorBorderStyle
      },

      "& > button:first-child": {
        borderLeft: errorBorderStyle
      },

      "& > button:last-child": {
        borderRight: errorBorderStyle
      }
    }
  };
});

export default ToggleButtonGroup;
